// FALLBACK (seit B3): Die maßgebliche Phasen-Konfiguration kommt aus dem
// Backend (GET /pipeline-config/, im Django-Admin gepflegt) und wird über
// den PipelineConfigProvider bezogen. Diese Konstanten dienen nur noch als
// Startwert vor der Antwort bzw. Notnagel bei API-Fehlern — hier nichts
// mehr pflegen, Änderungen gehören in den Admin.
export const ACCOUNT_PHASES = [
  {
    key: 'Open',
    label: 'Offen',
    next: 'Bedarf qualifizieren',
    checklist: ['Bedarf & Positionen erfasst', 'Ansprechpartner festgelegt'],
  },
  {
    key: 'Partially Filled',
    label: 'Teilweise erfüllt',
    next: 'Offene Positionen besetzen',
    checklist: ['Offene Positionen dokumentiert', 'Kandidaten im Gespräch'],
  },
  {
    key: 'Filled',
    label: 'Erfüllt',
    next: 'Zusammenarbeit pflegen',
    checklist: ['Onboarding abgeschlossen', 'Folgebedarf besprochen'],
  },
];

export const ACCOUNT_LOST = { key: 'Rejected', label: 'Abgelehnt' };
